import { action } from "typesafe-actions";

import { BookingsRequest, FlightsRequest, GateTesterActionTypes, GateTesterFormError, GateTesterResult } from "./types";

export const flightsFetchRequest = (request: FlightsRequest) =>
  action(GateTesterActionTypes.FLIGHTS_FETCH_REQUEST, request);

export const flightsFetchSuccess = (response: GateTesterResult) =>
  action(GateTesterActionTypes.FLIGHTS_FETCH_SUCCESS, response);

export const flightsFetchError = (payload: GateTesterFormError) => {
  return action(GateTesterActionTypes.FLIGHTS_FETCH_ERROR, payload);
};

export const bookingsFetchRequest = (request: BookingsRequest) =>
  action(GateTesterActionTypes.BOOKINGS_FETCH_REQUEST, request);

export const bookingsFetchSuccess = (response: GateTesterResult) =>
  action(GateTesterActionTypes.BOOKINGS_FETCH_SUCCESS, response);

export const bookingsFetchError = (payload: GateTesterFormError) => {
  return action(GateTesterActionTypes.BOOKINGS_FETCH_ERROR, payload);
};
